<template>
    <div v-if="!isLoaded">
        <div>
            <div class="row">
                <div class="col-lg-12">
                    Cargando...
                </div>
            </div>
        </div>
    </div>
    <div v-if="isLoaded">
        <form @submit.prevent="handleSubmit">
            <div>
                <div class="row mb-3">
                    <div class="col-lg-12">
                        <label for="project" class="form-label">Proyecto:</label>
                        <input disabled type="text" id="project" class="form-control"
                            :value="`${recordData.client} - ${recordData.identifier} - ${recordData.project}`">
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-lg-8">
                        <label for="activity" class="form-label">Actividad:</label>
                        <select v-model="recordData.activity_id" class="form-control">
                            <option v-for="act in activities" :key="act.activity_id" :value="act.activity_id">
                                {{ act.activity }}
                            </option>
                        </select>
                    </div>
                    <div class="col-lg-4">
                        <label for="eventDate" class="form-label">Fecha:</label>
                        <input type="date" id="eventDate" v-model="recordData.date" class="form-control" required />
                    </div>
                </div>
                <div v-if="!recordData.is_event" class="row mb-3 justify-content-center">
                    <div class="col-lg-3">
                        <label for="hours" class="form-label">Horas<span v-if="recordData.is_extra_time"> (Extra)</span>:</label>
                        <input type="number" min="0.25" step=".01" id="hours" v-model="recordData.total_hours"
                            class="form-control" />
                    </div>
                    <div v-if="showOnSite" class="col-lg-4">
                        <label for="activity" class="form-label">En Planta?</label>
                        <div class="form-check form-switch mb-0 ms-2 mt-2" id="on-site">
                            <input v-model="recordData.on_site" class="form-check-input form-check-input-warning"
                                type="checkbox" />
                        </div>
                    </div>
                </div>
                <div v-if="recordData.is_event" class="row mb-3">
                    <div class="col-lg-4">
                        <label for="startTime" class="form-label">Hora Inicio:</label>
                        <input type="time" id="startTime" v-model="recordData.start_time" class="form-control"
                            required />
                    </div>
                    <div class="col-lg-4">
                        <label for="endTime" class="form-label">Hora Fin:</label>
                        <input type="time" id="endTime" v-model="recordData.end_time" class="form-control" required />
                    </div>
                    <div v-if="showOnSite" class="col-lg-3">
                        <label for="activity" class="form-label">En Planta?</label>
                        <div class="form-check form-switch mb-0 ms-2 mt-2" id="on-site">
                            <input v-model="recordData.on_site" class="form-check-input form-check-input-warning"
                                type="checkbox" />
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-lg-12">
                        <label for="notes" class="form-label">Notas:</label>
                        <input type="text" id="notes" v-model="recordData.notes" class="form-control" />
                    </div>
                </div>
                <button size="lg" type="submit" class="btn btn-warning w-100 mb-0">Guardar</button>
            </div>
        </form>
    </div>
</template>

<script setup>
import { onMounted, ref, defineProps } from 'vue';

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const isLoaded = ref(false)
const isNexon = ref(false)
const showOnSite = ref(true)

const verifyIsNexon = (clientId) => {
    if (clientId === 2) {
        isNexon.value = true
        showOnSite.value = false
    } else {
        showOnSite.value = true
    }
}

const props = defineProps({
    selectedData: Object,
});

const recordData = ref({});

const activities = ref([]);


const fetchActivities = async () => {
    try {
        const response = await axios.get(`${API_BASE_URL}/user-activities`, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        activities.value = response.data; // Asigna los datos a variable `time_records`
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const loadRecordEditInfo = async () => {
    try {
        const response = await axios.post(`${API_BASE_URL}/record-edit-info`, { time_record_id: props.selectedData.time_record_id }, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        const data = response.data[0];

        if (data.is_auth === true) {
            alert('No puedes editar un Registro Autorizado')
            window.location.reload()
        }

        recordData.value.date = new Date(data.date).toISOString().split('T')[0];
        recordData.value.total_hours = data.total_hours;
        recordData.value.is_billable = data.is_billable;
        recordData.value.on_site = data.on_site;
        recordData.value.client_id = data.client_id;
        recordData.value.project_id = data.project_id;
        recordData.value.activity_id = data.activity_id;
        recordData.value.notes = data.notes;
        recordData.value.identifier = data.identifier;
        recordData.value.project = data.project;
        recordData.value.client = data.client;
        recordData.value.is_event = data.is_event;
        recordData.value.start_time = formatTime(data.start_time);
        recordData.value.end_time = formatTime(data.end_time);
        recordData.value.is_extra_time = data.is_extra_time

        verifyIsNexon(data.client_id)
        isLoaded.value = true

    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

const handleSubmit = async () => {

    if (recordData.value.is_event) {
        // Convertir start_time y end_time a objetos Date
        const startTime = new Date(`1970-01-01T${recordData.value.start_time}Z`);
        let endTime = new Date(`1970-01-01T${recordData.value.end_time}Z`);

        // Validación para asegurarse de que start_time sea menor que end_time
        if (startTime >= endTime) {
            alert('La hora de inicio debe ser menor que la hora de fin.');
            return; // Detiene la ejecución si la validación falla
        }
    }

    const body = {
        time_record_id: props.selectedData.time_record_id,
        on_site: recordData.value.on_site,
        notes: recordData.value.notes,
        date: recordData.value.date,
        total_hours: recordData.value.total_hours,
        activity_id: recordData.value.activity_id,
        start_time: recordData.value.start_time,
        end_time: recordData.value.end_time,
        is_event: recordData.value.is_event,
        is_extra_time: recordData.value.is_extra_time
    }

    try {

        if (recordData.value.is_event) {
            const response = await axios.post(`${API_BASE_URL}/update-event`, body, {
                headers: {
                    Authorization: `Bearer ${token}`, // Agrega el token en el header
                },
            });
            if (response.status == 200) {
                alert('Evento Actualizado')
                window.location.reload()
            }
        } else {
            const response = await axios.post(`${API_BASE_URL}/update-time-record`, body, {
                headers: {
                    Authorization: `Bearer ${token}`, // Agrega el token en el header
                },
            });
            if (response.status == 200) {
                alert('Registro Actualizado')
                window.location.reload()
            }
        }

    } catch (error) {
        console.error('Error al registrar la actividad:', error);
        // Verificar si hay respuesta del servidor
        if (error.response) {
            alert(error.response.data.msg || 'Ocurrió un error al registrar el evento.');
        } else {
            alert('Error de conexión con el servidor.');
        }
    }
}

const formatTime = (timeString) => {
    const time = new Date(timeString);
    // Convertimos la hora local a la hora en el formato HH:mm
    const hours = time.getUTCHours().toString().padStart(2, '0');  // Usamos getUTCHours para evitar desfases
    const minutes = time.getUTCMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
}

onMounted(async () => {
    await fetchActivities();
    await loadRecordEditInfo();
});
</script>